var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description"},[(_vm.type === 'kaali')?_c('KaaliDescription',{attrs:{"excerpt":_vm.excerpt,"description":_vm.description}}):_vm._e(),(_vm.type === 'wells')?_c('WellsDescription',{attrs:{"excerpt":_vm.excerpt,"description":_vm.description}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }